const STATUSES = {
	created: 'processing',
	paid: 'success',
	canceled: 'error',
	failed: 'error',
	loading: 'default',
}


export function getPaymentStatusDisplay(payment) {
	return payment != null ? STATUSES[payment.status] : 'default';
}
